import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { subjectsComplete } from '../../app.helpers';

@Injectable({
  providedIn: 'root',
})
export class TwilioPromiseErrorMediator implements OnDestroy {
  public get twilioHandledErrorOccured(): Observable<unknown> {
    return this.twilioHandledErrorOccured$.asObservable();
  }

  public get twilioUnhandledPromiseErrorOccured(): Observable<unknown> {
    return this.twilioUnhandledPromiseErrorOccured$.asObservable();
  }

  private twilioUnhandledPromiseErrorOccured$: Subject<unknown> = new Subject();
  private twilioHandledErrorOccured$: Subject<unknown> = new Subject();

  public ngOnDestroy(): void {
    subjectsComplete([this.twilioUnhandledPromiseErrorOccured$, this.twilioHandledErrorOccured$]);
  }

  public onTwilioUnhandledPromiseRejectionError(error: unknown): void {
    this.twilioUnhandledPromiseErrorOccured$.next(error);
  }

  public onTwilioHandledError(error: unknown): void {
    this.twilioHandledErrorOccured$.next(error);
  }
}
